export const ACCOUNTS_SET_ACCOUNTS = "accounts/set-accounts";
export const ACCOUNTS_SET_ACCOUNTTRADELIMIT =
  "accounts/set-account-trade-limits";
